import { makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = `${import.meta.env.VITE_API_URL}/audits`;
const makeRequestDebounced = createDebounce(makeRequest, 200);


export type GetAuditsMaintenanceResponse = {
  ok: boolean;
  data: Record<string, string>[];
  totalItems: number;
};

export async function getAuditsMaintenance({
  search = "",
  status = "",
  page = 1,
  itemsPerPage = 10,
} = {}): Promise<GetAuditsMaintenanceResponse> {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
  });

  if (status) params.append("filters[status]", status);
  if (search) params.append("search", search);

  const url = `${API_URL}/maintenance-vehicles?${params.toString()}`;

  const result = await makeRequestDebounced(url) as GetAuditsMaintenanceResponse;

  return {
    ok: result.ok,
    data: result.data,
    totalItems: result.totalItems,
  };
}
